/** Strings of debug screens. Owner: Platform (QA). */
export const debug = {
  'debug.screen.artlab': 'Художественная лаборатория',
} as const;
